<template>
    <div class="page">
        <van-cell-group title="加款记录">
            <van-cell title="加款方式" :value="record.type"/>
            <van-cell title="交易号/订单号" :value="record.transactionNo"/>
            <van-cell title="加款金额" :value="record.amount"/>
            <van-cell title="申请时间" :value="record.createTime"/>
            <van-cell title="审核时间" :value="record.completionTime"/>
            <van-cell title="加款状态" :value="toStateLabel(record.state)"/>
        </van-cell-group>
    </div>
</template>

<script>
import { Cell, CellGroup, Field, Button } from "vant";
import additionalApi from "@/api/additional";

const stateLabels = {
  0: "待验证",
  1: "加款成功",
  2: "加款失败",
  3: "已撤销",
};

export default {
    name: "AdditionalRecord",

    components: {
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Field.name]: Field,
        [Button.name]: Button
    },

    props: {
        id: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            record: {}
        }
    },

    mounted() {
        this.load();
    },

    methods: {
        toStateLabel: function(val) {
        return stateLabels[val];
        },
        load() {
            additionalApi.get(this.id).then(res => {
                if (res.success) {
                    this.record = res.data;
                } else {
                    // ignore
                }
            })
        }
    }
}
</script>

<style scoped>
.page {

}
.actions {
    margin: 10px 10px;
}
</style>